import Element, { type RootEntity, RootEntityType } from '@/modules/elements/models/Element'
import { useSpaceStore } from '@/modules/space/stores/SpaceStore'
import type User from '@/modules/user/models/User'
import { useUserStore } from '@/modules/user/stores/UserStore'

export function resolveRootEntityForElement(element: Element, rootEntity?: RootEntity): RootEntity | undefined {
  if (rootEntity) return rootEntity
  const { rootEntityType, rootEntityId } = element
  if (rootEntityType === RootEntityType.SPACE_PAGE) {
    return useSpaceStore().spacePageByPageId(rootEntityId)
  }
  return undefined
}

export function getUsersForMentions(rootEntity: RootEntity, rootEntityType: RootEntityType): User[] {
  const userStore = useUserStore()
  const spaceStore = useSpaceStore()
  return userStore.getFilteredUsers(rootEntity, rootEntityType, userStore.users, spaceStore.activeSpaces)
}

/** Lazy getter for TipTap editor context; resolves stores when mentions run. */
export function createMentionUsersGetter(element: Element, rootEntity?: RootEntity): () => User[] {
  return () => {
    const entity = resolveRootEntityForElement(element, rootEntity)
    if (!entity) return []
    return getUsersForMentions(entity, element.rootEntityType)
  }
}
